var SupplierSearch = (function () {
    'use strict';

    var _filterForm = null;
    var _resultsContainer = null;
    var _choicesInstances = [];

    /**
     * Initialize supplier filter functionality and bind events
     */
    var init = function () {
        _filterForm = $('form[data-ss-resultsurl]').first();
        if (!_filterForm.length) {
            return;
        }

        var resultsWrapper = _filterForm.attr('data-ss-resultswrapper');
        _resultsContainer = $('[' + resultsWrapper + ']');

        _initKeywordInput();
        _initChoices();
        _initShowMoreButton();
        _initSortToggle();
        _setInitialSortValue();
    };

    /**
     * Bind debounced input handler to keyword search field
     * Requires minimum 3 characters to trigger search, or clears results if empty
     */
    var _initKeywordInput = function() {
        var $keywordInput = $('input[name="Keyword"]');
        var debounceTimer;

        if ($keywordInput.length) {
            $keywordInput.on('input', function() {
                var $input = $(this);
                var keywordValue = $input.val().trim();

                clearTimeout(debounceTimer);

                if (keywordValue.length >= 3) {
                    debounceTimer = setTimeout(
                        function() {
                            _handleFilterChange($input);
                        },
                        500
                    );
                } else if (keywordValue.length === 0) {
                    _handleFilterChange($input);
                }
            });
        }
    };

    /**
     * Initialize Choices.js dropdowns with custom options and change handlers
     */
    var _initChoices = function() {
        _choicesInstances.forEach(function(instance) {
            instance.destroy();
        });
        _choicesInstances = [];

        document.querySelectorAll('select.choices__source').forEach(function(select) {
            var optionCount = Array.from(select.options).filter(function(opt) {
                return opt.value !== '';
            }).length;

            var noChoicesText = optionCount === 0
                ? 'Log in to access commercially sensitive information'
                : 'All choices selected';

            // eslint-disable-next-line no-undef
            var instance = new Choices(select, {
                removeItemButton: true,
                shouldSort: false,
                itemSelectText: '',
                noChoicesText: noChoicesText,
                searchEnabled: false,
                searchChoices: false
            });
            _choicesInstances.push(instance);

            select.addEventListener('change', function () {
                _handleFilterChange($(select));
            });
        });
    };

    /**
     * Bind "Show more" click: preserve sort, compute start from current items, append next results via _loadData.
     * @returns {void}
     */
    var _initShowMoreButton = function() {
        $(document).on('click', '[data-load-more-button]', function(e) {
            e.preventDefault();
            var $button = $(this);
            var currentUrlParams = new URLSearchParams(window.location.search);
            var params = new URLSearchParams(_filterForm.serialize());
            var sortValue = currentUrlParams.get('sort');
            var lastItemText = $('[data-ss-last-item]').first().text();
            var start = parseInt(lastItemText, 10) || 0;
            if (sortValue) params.set('sort', sortValue);
            if (start) params.set('start', start);

            $button.prop('disabled', true).text('Loading...');
            _loadData($button, params.toString(), $button);
            $button.prop('disabled', false);
        });
    };

    /**
     * Bind sort dropdown changes and trigger an AJAX refresh preserving pagination.
     *
     * - Reads current start from URL or form to keep position
     * - Sets ajaxsort=1 to indicate an AJAX sort request
     * - Delegates the request/DOM updates to _loadData
     *
     * @returns {void}
     */
    var _initSortToggle = function() {
        $(document).on('change', '[data-ss-sort-toggle]', function(e) {
            e.preventDefault();
            var $element = $(this);
            var currentUrlParams = new URLSearchParams(window.location.search);
            var params = new URLSearchParams(_filterForm.serialize());
            var sortValue = $element.val();
            var start = currentUrlParams.get('start') || 0;
            params.set('sort', sortValue);
            params.set('ajaxsort', '1');
            params.set('start', start);

            _loadData($element, params.toString());
        });
    };

    /**
     * Prepare submitData for filter changes and delegate to _loadData
     *
     * Removes sort, resets sort dropdown to default, and calls _loadData
     * with the prepared serialized data string.
     *
     * @param {jQuery} $element Trigger element used to set loading state
     */
    var _handleFilterChange = function($element) {
        var params = new URLSearchParams(_filterForm.serialize());
        params.delete('sort');
        var submitData = params.toString();

        var $sort = $('[data-ss-sort-toggle]');
        if ($sort.length) {
            $sort.val('asc');
        }

        _loadData($element, submitData);
    };

    /**
     * Fetch and render filtered supplier results via AJAX.
     *
     * Sends the provided serialized form data, updates history,
     * toggles loading state on the triggering element, and refreshes the results UI.
     *
     * @param {jQuery} $element Trigger element used to set loading state (used for loader overlay)
     * @param {string} submitData Serialized query string to send
     * @param {jQuery|null} [$loadMoreButton=null] When provided, treat as load-more: update button state and append items
     */
    var _loadData = function ($element, submitData, append = false) {
        var actionURL = _filterForm.attr('data-ss-resultsurl');

        _setLoadingState($element, true);
        _updateState(submitData);

        $.ajax({
            dataType: 'json',
            url: actionURL,
            data: submitData
        })
            .done(function(data) {
                if (!data.html) return;

                if (append) {
                    var $newContent = $(data.html);
                    var $existingContent = _resultsContainer.find('.b-tile-supplier-link');
                    var $newLinks = $newContent.find('.b-tile-supplier-link');
                    $existingContent.last().after($newLinks);
                } else {
                    _resultsContainer.html(data.html);
                    var resultsWrapper = _filterForm.attr('data-ss-resultswrapper');
                    _resultsContainer = $('[' + resultsWrapper + ']');
                }
                _updateLoadMoreButton(data.lastItem, data.totalCount);
                _syncCountData(data.lastItem, data.totalCount);
                _updateResultsVisibility();
                pubsubEvent.emit('pubsubEvent_ajaxComplete');
            })
            .always(function() {
                _setLoadingState($element, false);
            });
    };

    /**
     * Toggle loading animation state
     * @param {jQuery} $trigger - Element that triggered the loading
     * @param {boolean} state - True to show loader, false to hide
     */
    var _setLoadingState = function ($trigger, state) {
        var loaderClass = 'l-ajax-js__inner',
            $loader = $trigger.closest('.l-outer-container').find('.' + loaderClass).first();

        if (state === true) {
            $loader
                .removeClass(loaderClass + '--out')
                .addClass(loaderClass + '--in');
        } else if (state === false) {
            $loader
                .removeClass(loaderClass + '--out')
                .removeClass(loaderClass + '--in');
        }
    };

    /**
     * Update browser history with filtered parameters, excluding internal fields
     * @param {string} submitData - Serialized form data
     */
    var _updateState = function(submitData) {
        var urlParams = new URLSearchParams(submitData);
        urlParams.delete('PageID');
        urlParams.delete('SecurityID');

        var filteredData = urlParams.toString();
        var stateURL = filteredData ? ('?' + filteredData) : '';
        var stateObj = {
            data: submitData,
            stateURL: stateURL
        };

        if (Modernizr.history) {
            history.pushState(stateObj, '', stateURL);
        } else {
            window.history.pushState(stateObj, '', stateURL);
        }
    };

    /**
      * Set sort dropdown value from URL parameter
      */
    var _setInitialSortValue = function() {
        var urlParams = new URLSearchParams(window.location.search);
        var sortValue = urlParams.get('sort');
        if (sortValue) {
            $('[data-ss-sort-toggle]').val(sortValue);
        }
    };

    /**
     * Update pagination counters in DOM elements
     * @param {number} lastItem - Current last item number
     * @param {number} totalCount - Total number of items
     */
    var _syncCountData = function(lastItem, totalCount) {
        var $allLastItemElements = $('[data-ss-last-item]');
        var $allTotalCountElements = $('[data-ss-total-count]');

        $allLastItemElements.each(function() {
            var $element = $(this);
            $element.text(lastItem);
        });

        $allTotalCountElements.each(function() {
            var $element = $(this);
            $element.text(totalCount);
        });
    };

    /**
     * Show/hide results header and footer based on supplier results
     */
    var _updateResultsVisibility = function() {
        var $resultsHeader = $('[data-ss-results-header]');
        var $resultsFooter = $('[data-ss-results-footer]');
        var $supplierResults = _resultsContainer.find('.b-tile-supplier-link');

        if ($supplierResults.length === 0) {
            $resultsHeader.hide();
            $resultsFooter.hide();
        } else {
            $resultsHeader.show();
            $resultsFooter.show();
        }
    };

    /**
     * Update load more button text and visibility based on remaining results
     * @param {number} lastItem - Current last item number
     * @param {number} totalCount - Total number of items
     */
    var _updateLoadMoreButton = function(lastItem, totalCount) {
        var $loadMoreButton = $('[data-load-more-button]');

        if (lastItem >= totalCount) {
            $loadMoreButton.hide();
            return;
        }

        var remainingResults = totalCount - lastItem;
        var buttonText = remainingResults <= 10
            ? 'Show next ' + remainingResults + (remainingResults === 1 ? ' result' : ' results')
            : 'Show next 10 results';

        $loadMoreButton.text(buttonText).show();
    };

    return {
        init: init
    };
})();

$(document).ready(function() {
    SupplierSearch.init();
});
